import { useSelector } from 'react-redux';
import { selectUser, useCacheQuery } from 'gossamer-front-end';
import { isGroup, Task, TaskRow } from 'gossamer-model';

export interface MyActiveTasksResult {
  activeTasks: TaskRow[];
  completedTasks: TaskRow[];
  fractionCompleted: number;
  loaded: boolean;
}

export const useMyActiveTasks = (): MyActiveTasksResult => {
  const user = useSelector(selectUser);
  const taskQuery = useCacheQuery(
    Task,
    {
      where: {
        and: [{ fieldId: 'assigned_to', operator: 'eq', value: user?.userId }],
      },
      order: [['label', 'ASC']],
      limit: 1000,
    },
    !user?.userId,
  );
  const activeTasks = taskQuery?.data?.filter((task) => task.status === 'ACTIVE' && !isGroup(task.type)) ?? [];
  const completedTasks = taskQuery?.data?.filter((task) => task.status === 'COMPLETED' && !isGroup(task.type)) ?? [];
  const fractionCompleted =
    !!taskQuery.data && taskQuery.data.length > 0 ? completedTasks.length / taskQuery.data.length : 0;
  const loaded = !!taskQuery.data;
  return { activeTasks, completedTasks, fractionCompleted, loaded };
};
